import Area from "./Area";
import Length from "./Length";

export default class Rectangle {
	static NAME = 'rectangle';

	constructor( length, width ) {
		this.length = length;
		this.width = width;
	}

	get_name() {
		return Rectangle.NAME;
	}

	get_required_material() {
		return this;
	}

	get_enclosing_rectangle() {
		return this;
	}

	get_area() {
		return new Area( this.length.in_mm() * this.width.in_mm() );
	}

	get_circumference() {
		return this.width.add( this.width ).add( this.length ).add( this.length );
	}

	static from_cms( length, width ) {
		length = Length.from_cm( length );
		width = Length.from_cm( width );
		return new Rectangle( length, width );
	}

	get_length() {
		return this.length;
	}

	get_width() {
		return this.width;
	}

	get_shortest_side() {
		if ( this.length.in_mm() < this.width.in_mm() ) {
			return this.length;
		}

		return this.width;
	}

	get_longest_side() {
		if ( this.length.in_mm() > this.width.in_mm() ) {
			return this.length;
		}

		return this.width;
	}

	make_length_longest_side() {
		if ( this.width > this.length ) {
			return new Rectangle( this.width, this.length );
		}

		return this;
	}

	remove_sides( length ) {
		return new Rectangle( this.get_length().subtract( length ), this.get_width().subtract( length ) );
	}

	get_dimension_keys() {
		return ["length", "width"];
	}

	get_modifier_keys() {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			length: maximum_rectangle.get_length(),
			width: maximum_rectangle.get_width()
		};
	}

	serialize_primitives() {
		return {
			length: this.length.in_mm(),
			width: this.width.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Rectangle( new Length( primitives.length ), new Length( primitives.width ) );
	}
}
